export default "__VITE_ASSET__8f2ccbf6__"